import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { bind, InputDropdownMultiSelectFilter } from 'Mri.Web.Common';
import * as React from 'react';
import { DisplayListViewModel } from './DisplayListViewModel';

export interface IServiceOption {
    option: string;
    value: string | Mri.Contracts.ServiceLevel;
    type: 'serviceLevel' | 'contractOption';
}

export interface IServicesFilterProps {
    readonly vm: DisplayListViewModel;
}

@observer
export class ContractOptionsFilter extends React.Component<IServicesFilterProps> {
    public render() {
        const { onFilterDropdownToggle } = this.props.vm;

        return (
            <InputDropdownMultiSelectFilter
                title="Contract Options"
                filter={this.filter}
                disabled={this.props.vm.disabledFilters.includes('contractOptions')}
                options={this.options}
                style={{
                    minWidth: 400,
                }}
                print={this.print}
                onToggle={onFilterDropdownToggle}
                onChange={this.onChange}
                openOnMount
            />
        );
    }

    @action
    public componentWillUnmount() {
        this.onChange(undefined);
    }

    @bind
    @action
    private onChange(value: IServiceOption[] | undefined) {
        const { displayFilter } = this.props.vm;

        if (value != undefined) {
            displayFilter.contractOptions = value.filter(o => o.type == 'contractOption').map(o => o.value as string);
        } else {
            displayFilter.contractOptions = undefined;
        }
    }

    @computed
    private get filter() {
        const { displayFilter } = this.props.vm;
        if (!displayFilter.contractServiceLevels && !displayFilter.contractOptions) return;

        let filter: IServiceOption[] = [];

        const options = displayFilter.contractOptions
            ? (displayFilter.contractOptions
                .map((s: any) => this.options.find(o => o.value == s))
                .filter((s: any) => s) as IServiceOption[])
            : [];

        filter = filter.concat(options);

        return filter;
    }

    private print(entity: IServiceOption) {
        return entity.option;
    }

    private options: IServiceOption[] = [
        { option: 'Advanced Monitoring', value: 'advancedMonitoring', type: 'contractOption' },
        { option: 'Api Access', value: 'api', type: 'contractOption' },
        { option: 'Monitoring & Managed Services', value: 'monitoringManagedServices', type: 'contractOption' },
        { option: 'Managed Services', value: 'managedServices', type: 'contractOption' },
        { option: 'Field Services', value: 'onsiteFieldServices', type: 'contractOption' },
        { option: 'Proof of Play', value: 'proofOfPlay', type: 'contractOption' },
        { option: 'Customer Owned Parts', value: 'customerOwnedParts', type: 'contractOption' },
        { option: 'Demo', value: 'demo', type: 'contractOption' },
        { option: 'Firmware Updates', value: 'firmwareUpdates', type: 'contractOption' },
        { option: 'Advanced Warranty Alerts', value: 'advancedWarrantyAlerts', type: 'contractOption' },
        { option: 'Active', value: 'active', type: 'contractOption' },
    ];
}
